import { useQuery } from "@tanstack/react-query";
import { fetchPropertiesDrop } from "../../Properties/ducks/actions";
import { formatString } from "../../../../utils/formatString";

let businessUnitMenuItems = [
  { key: "all", label: "All Business Units", value: "all" },
];
const propertyMenuItems = [
  { key: "all", label: "All Properties", value: "all" },
];
export const usePropertiesDrop = () => {
  return useQuery({
    queryKey: ["propertiesDrop"],
    queryFn: fetchPropertiesDrop,
    select: (data) => {
      const propertiesList = data.map((item) => ({
        label: formatString(item.buildingName),
        value: item.propertyId,
      }));

      // ✅ Deduplicated Business Units
      const unitList = Object.values(
        data.reduce((acc, item) => {
          if (!acc[item.businessUnitId]) {
            acc[item.businessUnitId] = {
              label: formatString(item.businessUnitName),
              value: item.businessUnitId,
              key: item.businessUnitId, // link property to businessUnitId
            };
          }
          return acc;
        }, {})
      );
      let businessUnits = [...businessUnitMenuItems, ...unitList];
      let properties = [...propertyMenuItems, ...propertiesList];
      return { properties, businessUnits };
    },
    staleTime: 8 * 60 * 60 * 1000, // 8 hours
  });
};
